import {BaseAuthenticationMethod, AuthType, AuthTypeEnum} from './base-authentication-method';

export class AmDocumentanchor extends BaseAuthenticationMethod {
    type = 'documentanchor';
    name = 'document_anchors';
    authtype: AuthType = AuthTypeEnum.AFTERVIEW;
}
